import Header from "./layouts/Header";
import Footer from "./layouts/Footer";
import "./app.scss";
import JobView from "./modals/JobView";
import {Pagination, CircularProgress} from "@mui/material";
import {useEffect, useState} from "react";
import {apiUrl} from "./config";

function App() {
    const [page, setPage] = useState(1);
    const [data, setData] = useState(null);
    const [title, setTitle] = useState("");
    const [loading, setLoading] = useState(false);

    const handlePageChange = (event, value) => {
        setPage(value);
        window.scrollTo(0, 0);
    };

    useEffect(() => {
        const requestOptions = {
            method: "GET",
            redirect: "follow"
        };

        let url = apiUrl + "public-jobs/flter?page=" + page;

        if (title) {
            url += "&title=" + encodeURIComponent(title);
        }

        setLoading(true);

        fetch(url, requestOptions)
            .then(response => response.json())
            .then(result => setData(result))
            .catch(error => console.log("error", error))
            .finally(() => setLoading(false));
    }, [page, title]);

    let totalJobs = 0;
    let totalPages = 0;

    if (data && data.jobs) {
        totalJobs = typeof data.jobs.total === "number"
            ? data.jobs.total
            : (Array.isArray(data.jobs.data) ? data.jobs.data.length : 0);
        totalPages = Math.ceil(totalJobs / 20);
    }

    const handleSearch = (value) => {
        setPage(1);
        setTitle(value);
    };

    return (
        <div className="app">
            <Header onSearch={handleSearch}/>
            <main className="main">
                <div className="jobs-container container">
                    <div className="jobs-header-divider"/>
                    {loading && (
                        <div
                            className="jobs-loading"
                            style={{display: "flex", justifyContent: "center", padding: "20px 0"}}
                        >
                            <CircularProgress sx={{color: "#9D00FF"}}/>
                        </div>
                    )}
                    {data && data.jobs && (
                        <div className="jobs-summary">
                            Showing {totalJobs} open jobs
                        </div>
                    )}
                    <div className="jobs-grid">
                        {data && data.jobs && data.jobs.data.map((item, index) => (
                            <JobView key={index} item={item}/>
                        ))}
                    </div>
                    {totalPages > 1 && (
                        <div className="pagination-wrapper">
                            <Pagination
                                count={totalPages}
                                page={page}
                                onChange={handlePageChange}
                                hidePrevButton
                                hideNextButton
                                color="primary"
                            />
                        </div>
                    )}
                </div>
            </main>
            <Footer/>
        </div>
    );
}

export default App;
